export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-speed-up-line',
      title: '极速播放',
      desc: '先进CDN加速技术，智能码率调节，确保播放流畅不卡顿，带来丝滑观影体验。',
    },
    {
      icon: 'ri-4k-line',
      title: '高清画质',
      desc: '支持1080P高清与4K超清画质，免费用户即可畅享高清观影，画面细节更丰富。',
    },
    {
      icon: 'ri-stack-line',
      title: '海量资源',
      desc: '超过五万部影视资源，涵盖电影、电视剧、综艺、动漫等八大类别，应有尽有。',
    },
    {
      icon: 'ri-device-line',
      title: '多端支持',
      desc: '支持手机、平板、电脑和智能电视，随时随地观影，大屏小屏随心切换。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全可靠',
      desc: '严格的内容审核机制，绿色安全无广告骚扰，保护您的观影隐私和安全。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '贴心服务',
      desc: '7×24小时客服支持，快速响应用户需求，让您观影无忧，享受优质服务体验。',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            为什么选择芒果视频？
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            对比蜜桃视频、糖豆视频、蘑菇视频、蓝莓视频等平台，芒果视频拥有独特优势
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex gap-4 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 transition-all duration-300 hover:border-primary-200 hover:scale-[1.02]"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 flex-shrink-0">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 font-heading">
                  {feature.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 md:p-8 rounded-2xl bg-gradient-to-r from-primary-500 to-accent-500 text-background-50 text-center">
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold font-heading">50,000+</div>
              <div className="text-xs md:text-sm text-background-50/80 mt-1">影视资源</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold font-heading">8</div>
              <div className="text-xs md:text-sm text-background-50/80 mt-1">内容分类</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold font-heading">1000万+</div>
              <div className="text-xs md:text-sm text-background-50/80 mt-1">活跃用户</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold font-heading">99.9%</div>
              <div className="text-xs md:text-sm text-background-50/80 mt-1">播放成功率</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}